// src/contexts/ErrorContext.js

import React, { createContext, useState, useContext } from 'react';

const ErrorContext = createContext();

export const useError = () => useContext(ErrorContext);

export const ErrorProvider = ({ children }) => {
  const [hasError, setHasError] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  const showError = (message) => {
    setErrorMessage(message);
    setHasError(true);
  };

  const clearError = () => {
    setErrorMessage('');
    setHasError(false);
  };

  return (
    <ErrorContext.Provider value={{ hasError, errorMessage, showError, clearError }}>
      {children}
    </ErrorContext.Provider>
  );
};
